import { useState } from 'react';
import { useSite } from '../context/SiteContext';
import { buildFaqs } from '../data/course';
import { ChevronDownIcon } from './Icons';

export default function FAQ() {
  const { course, payment } = useSite();
  const [open, setOpen] = useState(0);
  const faqs = buildFaqs(course, payment);

  return (
    <section id="faq" className="bg-slate-50 py-20">
      <div className="container-x max-w-3xl">
        <div className="text-center">
          <span className="eyebrow">প্রশ্নোত্তর</span>
          <h2 className="section-title">সাধারণ কিছু প্রশ্ন</h2>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-xl bg-white ring-1 ring-slate-200">
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-lg font-semibold text-slate-800"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-${i}`}
                >
                  {f.q}
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                </button>
                <div id={`faq-${i}`} className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 leading-relaxed text-slate-600">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
